/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { MeetingsEmptySlotsCancelParams } from './meetingsEmptySlotsCancelParams';

/**
 * Request model for meetings empty slots cancel job
 */
export interface RunMeetingsEmptySlotsCancelJobRequest {
  type: 'meetings_empty_slots_cancel';
  params: MeetingsEmptySlotsCancelParams;
  allowOverlappingJobs?: boolean;
}
